// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonButton,
  IonButtons,
  IonContent,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonText,
  IonToolbar
} from "@ionic/react"
import { useState } from "react"
import { useLocales } from "react-localized"
import Select, { SingleValue } from 'react-select'
import { ResponsiveIonCol } from "./ResponsiveIonCol"


interface ModalProps {
  close(): void
  isOpen: boolean
  onSelected(value: any): void
}


const BuyerModal: React.FC<ModalProps> = ({
  close,
  isOpen,
  onSelected
}) => {
  const {gettext} = useLocales()
  return (
    <IonModal animated={false} backdropDismiss={false} className="page-modal" isOpen={isOpen}>
      <IonContent>
        <main>
          <IonGrid>
            <IonRow>
              <ResponsiveIonCol>
                <IonText>
                <p style={{marginBottom: "22px"}}>
                  {gettext("Select the purchasing entity from the list below.")}
                </p>
                </IonText>
                <IonText>
                  <Select
                    classNames={{
                      container: (state) => "select-container",
                      control: (state) => "control",
                      indicatorsContainer: (state) => "indicators",
                      menuList: (state) => "menu-list",
                      menu: (state) => "menu",
                      option: (state) => (!!state.isFocused) ? "focus" : "",
                      placeholder: (state) => "placeholder",
                      singleValue: (state) => "current-value",
                      valueContainer: (state) => "value-container"
                    }}
                    classNamePrefix="options"
                    onChange={(option: SingleValue<any>) => {
                      onSelected(option)
                    }}
                    options={[
                      {value: "Molano B.V.", label: gettext("Molano B.V.")},
                      {value: "Molano IMEX B.V.", label: gettext("Molano IMEX B.V.")},
                    ]}
                  />
                </IonText>
              </ResponsiveIonCol>
            </IonRow>
          </IonGrid>
        </main>
      </IonContent>
      <IonToolbar>
        <IonButtons slot="start">
          <IonButton color="medium" onClick={() => {
            close()
          }}>
            {gettext("Cancel")}
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonModal>
  )
}

const BuyerItem: React.FC<{
  placeholder: string,
  onSelected(value: any): void, value: any
}> = ({
  onSelected,
  placeholder,
  value
}) => {
  const {gettext} = useLocales()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <>
      <IonItem
        className="clickable"
        detail={true}
        lines="full"
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <IonLabel>
          <h2>{gettext("Buyer")}</h2>
          <p>{(!!value) ? value.label : placeholder}</p>
        </IonLabel>
      </IonItem>
      <BuyerModal
        close={() => { setIsOpen(false) }}
        isOpen={isOpen}
        onSelected={(value: any) => {
          onSelected(value)
          setIsOpen(false)
        }}
      />
    </>
  )
}


export { BuyerItem, BuyerModal }